import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_447: DocMigration = {
  maxSchemaVersion: "0.0.447",
  description: "Remove ROOF_DORMER_OVERHANG_DIM_* categories from view templates",
  apply(json: any): any {
    const viewTemplates = json.viewTemplates;
    if (!viewTemplates) {
      return json;
    }
    for (const viewTemplateId in viewTemplates) {
      const newCategories: string[] = [];
      const viewTemplate = viewTemplates[viewTemplateId];
      for (const category of viewTemplate.categories) {
        if (isRoofDormerOverhangDimCategory(category)) {
          continue;
        }
        newCategories.push(category);
      }
      viewTemplate.categories = newCategories;
    }

    return json;
  },
};

function isRoofDormerOverhangDimCategory(category: string): boolean {
  switch (category) {
    case "ROOF_DORMER_FRAMING": // deprecated to built in plan sets only
    case "ROOF_DORMER_OVERHANG_DIM_LABEL":
    case "ROOF_DORMER_OVERHANG_DIM_LINE":
    case "ROOF_DORMER_OVERHANG_DIM_LINEWORK":
    case "ROOF_DORMER_OVERHANG_DIM_TICK":
    case "ROOF_DORMER_OVERHANG_DIM_WITNESS":
    case "ROOF_DORMER_OVERHANG_DIM_GROUP":
      return true;
    default:
      return false;
  }
}

export default migration_0_0_447;
